import React from 'react';
import Button from '../components/Button';
import CallOut from '../components/CallOut';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import installIntegration from '../admin/integration/installIntegration';
import styles from './InvitationGoogleConnect.module.scss';
import { setAutoShowInvitationModal } from '../organization/autoShowInvitationModal';
import { useAppDispatch } from '../app/redux/useAppSelector';

const InvitationGoogleConnect = () => {
  const dispatch = useAppDispatch();
  const handleClick = () => {
    const redirectUrl = document.location.href;
    setAutoShowInvitationModal();
    installIntegration({ platform: 'google', dispatch, redirectUrl });
  };

  return (
    <CallOut variant="info">
      <div className={styles.connectMessage}>
        Connect Google Workspace to easily pick teammates to invite
      </div>
      <Button variant="secondary" size="small" onClick={handleClick}>
        <div className={styles.connectButton}>
          <ExternalBrandLogo brand="google" height={12} />
          <span>Connect to Google Workspace</span>
        </div>
      </Button>
    </CallOut>
  );
};

export default InvitationGoogleConnect;
